/**
 * Created by pyt on 2017-03-07.
 */
export default class Exception {
  error: string;

  constructor(error: string) {
    this.error = error;
  }
}
